export default "__VITE_ASSET__74c82280__"